import { AfterViewInit, Component, ComponentRef, Input, OnDestroy, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ICerFormViewType } from './cer-form-view-type.interface';
import { CerAppRouteService } from 'src/cer-app/cer-app-route/cer-app-route.service';
import { CerFormView } from '@form/cer-form-view';
import { UiCommandEvent } from '@ui/cer-ui-types';
import { Subscription } from 'rxjs';
import { ICerFormViewCustomComponent } from './icer-form-view-custom-component';
import { CerFormService } from '@form/cer-form.service';

@Component({
  selector: 'cer-form-view-type-custom',
  template: '<ng-template let-view><ng-container #container/></ng-template>'
})
export class CerFormViewTypeCustomComponent implements AfterViewInit, OnDestroy, ICerFormViewType {

  constructor(private r: CerAppRouteService, private formService: CerFormService) {}

  private subscriptionManager$: Subscription = new Subscription();

  public ngOnDestroy() {
    this.subscriptionManager$.unsubscribe();
  }

  @ViewChild(TemplateRef<any>) template!: TemplateRef<any>;
  
  private _view: CerFormView;
  get view(): CerFormView { return this._view; };
  @Input() set view(view: CerFormView) {
    this._view = view;
    this.subscriptionManager$.add(
        this._view.commandSubscribe(e => this.onCommand(e))
    );
    this.subscriptionManager$.add(
        this.formService.formCommand$.subscribe(e => this.onCommand(e))
    );
  }

  public onCommand(e: UiCommandEvent) {
    if (this.component != null && <any> this.component != <any> e.appComponent) {
      this.component.onViewCommand(e);
    }
  }

  private container: ViewContainerRef;
  @ViewChild('container', { read: ViewContainerRef }) set containerRef(c: ViewContainerRef) {
    if (c && this.container  != c) {
      this.container = c;
      this.createComponent();
    }
  }

  private component: ICerFormViewCustomComponent;

  ngAfterViewInit() {
    this.createComponent();
  }

  private createComponent() {
    if (this.container && !this.component) {
      const componentRef: ComponentRef<any> = this.container.createComponent(this.view.routeOptions.routeComponentType);
      if (componentRef?.instance?.setView) {
        this.component = componentRef?.instance as ICerFormViewCustomComponent;
        this.component.setView(this.view);
      }
      this.r.setIsLoading(false);
    }
  }
  
}

